import CommentsSearch from './CommentsSearch';

export default CommentsSearch;
